// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"dc0c6214","451":"7ca7ba19","453":"741742e3","482":"a50b9413","491":"f8774f92"}[chunkId] + ".chunk.js";
};